var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"authui"}},[_vm._t("default"),_c('div',{attrs:{"id":"firebaseui-auth-container"}}),_vm._v("\n  "+_vm._s(_vm.config)+"\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }